import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';

import LaunchHeader from "./LaunchHeader";
import Footer from "./Footer";
// import Button from '@material-ui/core/Button';
import LibraryRegistration from '../components/LibraryRegistration'
import TeamRegistration from '../components/TeamRegistration'

const styles = theme => ({
  
    paper: {
        padding: theme.spacing.unit * 2,
        boxShadow: 'none'
    },

    banner: {
        color: '#fff',
        paddingTop: 100,
        paddingBottom: 150,
        background: `url("${require("../assets/5.jpg")}")`,
        backgroundSize: 'cover',
        position: 'relative',
        zIndex: 1,        
        // '&:before': {
        //     background: `url("${require("../assets/hero-banner-bg.png")}")`,
        //     backgroundSize: 'cover',
        //     position: 'relative',
        //     zIndex: 1
        // },
        '&:after': {            
            content: "no-open-quote",
            background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
            // background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
            // background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
            display: 'block',
            zIndex: -1,
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            opacity: 0.8
        }
    },
   
    centerText: {
        textAlign: 'center'
    },

    container: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        //top: 100,
        zIndex: 1,
        // width: 400
    },

    contentContainer: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        top: -100,
        zIndex: 2,
        color: '#fff'
        // width: 400
    },

    sectionMargin: {
        top: -50
    },

    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
    },

    // paper: {
    //     padding: theme.spacing.unit * 2,
    //     // textAlign: 'center',
    //     boxShadow: 'none'
    //     // color: theme.palette.text.secondary,
    // },

    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },

    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },

    
});

class LaunchLayout extends Component {
    static contextTypes = {
        router: PropTypes.object,
    }

    defaultMenu(){
        let url = window.location.pathname.split ('/')[1];
        let menu = url === "alllibraries" ? 1 : url === "fllteams" ? 2 : 0
        return menu;
    }

    render() {
        const {  classes, children } = this.props;

        return (
            <div>
                <LaunchHeader />
                <section className={classes.banner}>
                   <div className={`${classes.container} ${classes.centerText}`}>
                        <div className={classes.sectionDesktop} style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                            <img alt="logo" src={require('../assets/logo.png')} style={{ opacity: 0.8 }} />
                        </div>
                        <div className={classes.sectionMobile} style={{ textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                            <img alt="logo" src={require('../assets/logo.png')} style={{ opacity: 0.8 }} height={150} />
                        </div>
                        <Typography variant="overline" color="inherit">
                            The Sacramento team, Thunderbots, has been participating in the First Lego League (FLL) since 2013.
                        </Typography>
                        {this.defaultMenu() === 0 &&
                            <div>
								{/* <Typography variant="h4" color="inherit" style={{ textTransform: 'uppercase', lineHeight: 2 }}>
									We Work for Solutions
								</Typography>  
												
								<Typography variant="caption" color="inherit" style={{ fontSize: 15, lineHeight: 1.5 }}>
									We do the work to find solutions with guidance from our coaches and mentors
								</Typography> */}
                                <Typography variant="h5" color="inherit" style={{ textTransform: 'uppercase', lineHeight: 2 }}>
                                    The Thunderbots efforts on STEM exchange program were featured in FLL blog
								</Typography>
                            </div>
                        }

                        {this.defaultMenu() === 1 &&
                          <div>
                             	<Typography variant="caption" color="inherit" style={{ fontSize: 15, lineHeight: 1.5 }}>
                              		Inspired by our roles as Global Innovation Ambassadors , we started the STEM learning exchange program in 2018 at Orangevale Library,California. We wished to enroll more libraries across the globe  into this program. Please register using the link below
								</Typography>
                             	<LibraryRegistration/>
                          </div>
                        }

                        {this.defaultMenu() === 2 &&
                            <div>
                                <Typography variant="caption" color="inherit" style={{ fontSize: 15, lineHeight: 1.5 }}>
                                    Inspired by our roles as Global Innovation Ambassadors , we started the STEM learning exchange program in 2018 at Orangevale Library, California. We wished to enroll more teams across the globe into this program and use it to expand to libraries worldwide. If you are First team that is interested, please register using the link below.
                                </Typography>                               
                                <TeamRegistration />
                            </div> 
                        }
                    </div>
                </section>
                <section className={`${classes.content} ${classes.sectionMargin}`}>
                   <div className={`${classes.contentContainer}`}>
                        <Paper className={classes.paper}>
                            {children}
                        </Paper>                        
                   </div>                    
                </section>  
                <Footer />
            </div>
        )
    }
}

LaunchLayout.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LaunchLayout);